module.exports = __webpack_public_path__ + "static/media/AzoSansMedium.a560eaf7.woff";